import React from "react";

import styles from "./brandkit.components.module.scss";

const EmptyMessage = () => {
  return (
    <div className={styles.emptyMessage}>
      <video className={styles.emptyImage} loop autoPlay playsInline muted>
        <source src="/images/Blackhole.webm" type="video/webm" />
        <source src="/images/Blackhole.mp4" type="video/mp4" />
      </video>
      <div className={styles.errorMessageContent}>
        <div className={styles.errorMessageTitle}>
          <span>
            Do
            <br /> you believe in
          </span>
          <span>
            Black
            <br /> Holes?
          </span>
        </div>
        <div className={styles.errorMessageSubText}>
          <span>
            You better do, because nothing
            <br /> else explains this empty screen.
            <br />
          </span>
          <span>
            ...That or you haven’t added <br /> anything here yet.
          </span>
        </div>
      </div>
    </div>
  );
};

export default EmptyMessage;